import React, { useEffect } from "react";
import Header from "./Header";

const ProcessCompleteJourney = ({
  isCompleteJourneyEnabled,
  showJourneyCompleteSuccess,
  toNextPage,
  journeySteps,
}) => {
  useEffect(() => {
    if (
      isCompleteJourneyEnabled &&
      journeySteps == 8 &&
      !showJourneyCompleteSuccess
    ) {
      document.getElementById("completebutton").click();
    }
    if (showJourneyCompleteSuccess) {
      toNextPage();
    }
  }, [isCompleteJourneyEnabled, showJourneyCompleteSuccess]);
  return (
    <div>
      <div>
        <Header />
        <p>Process Complete Journey</p>
        <p id="completeStatus"></p>
      </div>
      <div style={{ display: "none" }} className="button-container">
        <button id="completebutton" className="complete-journey-button">
          Complete Journey
        </button>
      </div>
    </div>
  );
};

export default ProcessCompleteJourney;
